{
	"ariaInvertMask": "Invert Mask",
	"ariaMaskingAdjustmentsPanel": "Masking Adjustments Panel",
	"ariaSwitchToMaskAddBrush": "Switch To Mask Add Brush",
	"ariaSwitchToMaskEraseBrush": "Switch To Mask Erase Brush",
	"ariaToggleMaskColorAwareBrush": "Toggle Mask Color Aware Brush",
	"autoMask": "Auto Mask",
	"invert": "Invert",
	"noMaskCreated": "No mask created yet",
	"noMaskSelected": "No mask is selected",
	"sliderBlacks": "Blacks",
	"sliderClarity": "Clarity",
	"sliderContrast": "Contrast",
	"sliderDehaze": "Dehaze",
	"sliderDensity": "Density",
	"sliderExposure": "Exposure",
	"sliderFeather": "Feather",
	"sliderFlow": "Flow",
	"sliderHighlights": "Highlights",
	"sliderSaturation": "Saturation",
	"sliderShadows": "Shadows",
	"sliderSharpness": "Sharpness",
	"sliderSize": "Size",
	"sliderStrength": "Strength",
	"sliderTemp": "Temp",
	"sliderTexture": "Texture",
	"sliderTint": "Tint",
	"sliderWhites": "Whites"
}
